<app-loading-circle 
 *ngIf="loading">

</app-loading-circle>

<app-ion-common-header
*ngIf="!loading"
  [id]="headerId"
  (backHeader)="back()"
  [title]="titlePage"
  [isDark]="true"
></app-ion-common-header>

<ion-content *ngIf="!loading">
  <div
    class="content-list content-scroll"
    [ngClass]="{ 'content-list--with-button': true }"
  >
    <div class="display-rg-dark ids-pt-8 ids-pb-6">
      <h2
        id="idTitle"
        role="heading"
        [attr.aria-level]="title"
        [attr.aria-label]="title"
      >
        {{ title ? title : "" }}
      </h2>
      <!-- <h3 role="heading" [attr.aria-level]="subTitle" [attr.aria-label]="subTitle">{{subTitle}}</h3> -->
    </div>

    <div class="message">
      <h3
        [id]="idMessageOverView"
        role="heading"
        [attr.aria-level]="message"
        [attr.aria-label]="message"
      >
        {{ message }}
      </h3>
    </div>

    <div [id]="idStepsOverView" class="steps" *ngFor="let step of steps">
      <div class="steps__content">
        <div class="iconDiv" aria-hidden="true">
          <img class="imgIcon" [src]="step.icon" />
        </div>
        <span>{{ step.label }}</span>
        <div
          class="steps__margin"
          *ngIf="!checkLastItem(step)"
          aria-hidden="true"
        ></div>
      </div>
    </div>
  </div>

  <app-ion-common-button
    [id]="idButtonOverView"
    (clickButton)="clickNext()"
    typeButton="light"
    label="Continuar"
  ></app-ion-common-button>
</ion-content>
